import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import CardpreviewQue5 from './CardpreviewQue5';
import CardPreviewQue6 from './CardPreviewQue6';
import CardPreviewQue7 from './CardPreviewQue7';
import CardPreviewQue8 from './CardPreviewQue8';
import CardPreviewQue9 from './CardPreviewQue9';

/**
 * Layout number -> component.
 * Navo layout add karvo hoy to bas ahiya ek line umero (ane upar import karo).
 * CardBg ma buttons pan aa list parthi automatic banse.
 */
export const PREVIEW_LAYOUTS = {
    5: CardpreviewQue5,
    6: CardPreviewQue6,
    7: CardPreviewQue7,
    8: CardPreviewQue8,
    9: CardPreviewQue9,
};


const ImagePreviewModal = ({
    show,
    onHide,
    images,
    currentIndex,
    onNavigate,
    totalImages,
    currentPage,
    itemsPerPage,
    layout = null,
}) => {
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (!show) return;

            if (e.key === 'ArrowLeft') {
                onNavigate(currentIndex - 1, 'prev');
            } else if (e.key === 'ArrowRight') {
                onNavigate(currentIndex + 1, 'next');
            } else if (e.key === 'Escape') {
                onHide();
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [show, currentIndex, onNavigate, onHide]);

    if (!show || !images.length) return null;

    // Calculate the actual position in the full dataset
    const actualIndex = (currentPage - 1) * itemsPerPage + currentIndex + 1;
    const currentImage = images[currentIndex];

    const renderContent = () => {
        const LayoutComponent = layout ? PREVIEW_LAYOUTS[layout] : null;

        if (LayoutComponent) {
            return (
                <div className="relative h-[650px] w-[480px] max-h-full">
                    <LayoutComponent image={currentImage} />
                </div>
            );
        }

        return (
            <img
                src={currentImage}
                alt="Preview"
                className="max-w-full max-h-full object-contain"
            />
        );
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-99999">
            <div className="relative w-full h-full flex items-center justify-center">
                {/* Close Button */}
                <button
                    onClick={onHide}
                    className="absolute top-4 right-4 bg-gray-800 text-white pt-1 rounded-full focus:outline-none hover:bg-white hover:text-black h-10 w-10"
                >
                    <FontAwesomeIcon icon={faTimes} className="w-5 h-5" />
                </button>

                {/* Image Counter */}
                <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-4 py-2 rounded-full shadow-lg z-10">
                    <span className="font-medium">
                        {actualIndex} of {totalImages}
                    </span>
                </div>

                {/* Image / Card layout */}
                {renderContent()}

                {/* Left Navigation Button */}
                {(currentIndex > 0 || currentPage > 1) && (
                    <button
                        onClick={() => onNavigate(currentIndex - 1, 'prev')}
                        className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white text-gray-700 pt-1 rounded-full shadow-lg hover:bg-gray-200 h-10 w-10 text-center z-10"
                    >
                        <FontAwesomeIcon icon={faChevronLeft} className="w-5 h-5" />
                    </button>
                )}

                {/* Right Navigation Button */}
                {actualIndex < totalImages && (
                    <button
                        onClick={() => onNavigate(currentIndex + 1, 'next')}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white text-gray-700 pt-1 rounded-full shadow-lg hover:bg-gray-200 h-10 w-10 text-center z-10"
                    >
                        <FontAwesomeIcon icon={faChevronRight} className="w-5 h-5" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default ImagePreviewModal;